import * as React from 'react';
import type { TemplateConfigurationStatus } from '@klareospace/pharos-lib-types';

import { STATUS_BADGE_COLORS } from '../status-badge';
import { StatusBadge } from '../status-badge';

// ─── Style Map ────────────────────────────────────────────────────────────────

export const SHIPPER_STATUS_STYLES: Record<TemplateConfigurationStatus, string> = {
  active: STATUS_BADGE_COLORS.success,
  archived: STATUS_BADGE_COLORS.neutral,
  inactive: STATUS_BADGE_COLORS.warning,
  pending: STATUS_BADGE_COLORS.info,
};

// ─── Props ────────────────────────────────────────────────────────────────────

export interface ShipperStatusBadgeProps {
  /** Optional additional CSS classes */
  className?: string;
  /** The translated label to show inside the badge */
  label: string;
  /** The shipper (template configuration) status to display */
  status: TemplateConfigurationStatus;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function ShipperStatusBadge({ className, label, status }: ShipperStatusBadgeProps): React.JSX.Element {
  return <StatusBadge className={className} label={label} status={status} styles={SHIPPER_STATUS_STYLES} />;
}
